const taskUri = {
	default: "tasks" ,
	paramId: "tasks/:id" ,
	search: "tasks/search" ,
	preview: "tasks/:id/preview" ,
	paging: "tasks/paging" ,
	quickSearch: "tasks/quicksearch" ,
	init: "tasks/change-infos/init" ,
    touch: "tasks/touch?ids=:ids",
    deleteAll: "tasks/delete-all",
    createTaskEvaluation: "tasks/create-task-evaluation",
    createTaskCondition: "tasks/create-task-cond"
};

export default taskUri;